import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { LogistikOrder } from '@chancenwerk/db/LogistikOrder.js';
import { LogistikOrderDeliveryStateEnum } from '@chancenwerk/db/enums/LogistikEnums.js';
import { ChromiumDialog } from '@chancenwerk/design/components/cr-dialog.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

/**
 * @customElement logistik-dialog-delivery-request
 */
@customElement('logistik-dialog-delivery-request')
export class LogistikDialogDeliveryRequest extends ChromiumDialog<void> {
  @state() public order = new RXController(this, new LogistikOrder({}));

  static override get element_name() {
    return 'logistik-dialog-delivery-request';
  }

  override render() {
    return html`
      <cr-flex space="md" padding="xl">
        <cr-h2>Empfangsbestätigung</cr-h2>
        <cr-text>Haben Sie Ihre Bestellung erhalten?</cr-text>
        <cr-flex horizontal crossaxis-center space="md">
          <cr-button
            @click=${async () => {
              await LogistikOrder.setDeliveryStatus(this.order.value, LogistikOrderDeliveryStateEnum.RECEIVED)();
              this.close();
            }}
          >
            Ja
          </cr-button>
          <cr-button
            @click=${async () => {
              await LogistikOrder.setDeliveryStatus(this.order.value, LogistikOrderDeliveryStateEnum.NOT_RECEIVED)();
              this.close();
            }}
          >
            Nein
          </cr-button>
        </cr-flex>
      </cr-flex>
    `;
  }
}
